import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { class: "align-middle" }
const _hoisted_3 = { class: "align-middle" }
const _hoisted_4 = { class: "align-middle" }
const _hoisted_5 = { class: "align-middle" }

import ConsistencyAnalysisCircles from '@Evaluation/Common/Components/ConsistencyAnalysisCircles.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'ConsistencyAnalysisLegend',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_2, [
            _createVNode(ConsistencyAnalysisCircles, { status: 'Inconsistent' })
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("td", null, [
            _createElementVNode("strong", null, "Inconsistency score: above 20%"),
            _createElementVNode("br"),
            _createTextVNode(" Your answers are inconsistent. We recommend you go back and revisit the questions that are contributing most to your inconsistency score. The software will highlight the key questions for you. ")
          ], -1 /* CACHED */))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_3, [
            _createVNode(ConsistencyAnalysisCircles, { status: 'Acceptable' })
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("td", null, [
            _createElementVNode("strong", null, "Inconsistency score: 10-20%"),
            _createElementVNode("br"),
            _createTextVNode(" Your inconsistency is a little higher than it should be. If your decision involves lots of \"highly subjective\" issues, this level of inconsistency might be okay - to be human is to be inconsistent! If your decision is mostly driven by \"hard numbers\", your consistency should be lower - you may want to go back and review your answers to key questions. ")
          ], -1 /* CACHED */))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_4, [
            _createVNode(ConsistencyAnalysisCircles, { status: 'Consistent' })
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("td", null, [
            _createElementVNode("strong", null, "Inconsistency score: below 10%"),
            _createElementVNode("br"),
            _createTextVNode(" Great job! The consistency of your answers is good! ")
          ], -1 /* CACHED */))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_5, [
            _createVNode(ConsistencyAnalysisCircles, { status: 'Unknown' })
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("td", null, [
            _createElementVNode("strong", null, "Inconsistency score: Unknown"),
            _createElementVNode("br"),
            _createTextVNode(" Not enough data to calculate it. ")
          ], -1 /* CACHED */))
        ])
      ])
    ])
  ]))
}
}

})